import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import { ArrowDown } from "lucide-react";

export const Hero = () => {
  const [ref, isVisible] = useScrollAnimation();

  const handleViewWork = () => {
    const el = document.querySelector("#work");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="min-h-[90vh] flex items-center justify-center px-5 md:px-10 pt-[72px]">
      <div
        ref={ref}
        className={`max-w-[800px] text-center transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <h1
          className="text-[clamp(38px,7vw,64px)] font-semibold leading-[1.1] tracking-tight text-[#0A0A0A] mb-7"
        >
          Built by Founders.
          <br />
          For Founders.
        </h1>

        <p className="text-[clamp(16px,2.2vw,18px)] font-normal leading-[1.65] text-[rgba(10,10,10,0.5)] max-w-[560px] mx-auto mb-10">
          A strategy-first creative studio helping ambitious founders build
          brands that think clearly, speak powerfully, and grow intentionally.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <a
            href="https://calendly.com/thefussedbulb/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-[#4A7CC9] hover:bg-[#3D6BB5] text-white font-semibold text-[15px] px-8 py-[14px] rounded-full transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] no-underline tracking-wide"
          >
            Book a Strategy Call
          </a>

          <button
            onClick={handleViewWork}
            className="inline-flex items-center gap-2 bg-transparent border-none cursor-pointer text-[14px] font-medium text-[#0A0A0A] hover:text-[#4A7CC9] transition-colors duration-300 group"
          >
            View Selected Work
            <ArrowDown className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-y-0.5" />
          </button>
        </div>
      </div>
    </section>
  );
};
